<div class="container landing-container primary-page-wrapper business-page-wrapper">
    <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb" class="breadcrumb-block d-none d-lg-block">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Sydney</li>
            <li class="breadcrumb-item">Restaurants</li>
            <li class="breadcrumb-item" aria-current="page">Cotogna</li>
        </ol>
    </nav>
    <div class="page-head">
        <div class="head-inner-left">
            <div class="name-wrap">
                <!-- <h1 class="page-title">
                    <span class="name">
                        Cotogna
                    </span>
                    <span class="status">open now</span>
                </h1> -->
                <div class="page-title-wrap">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <h1 class="page-title">Cotogna</h1>
                                </td>
                                <td>
                                    <span class="status">Open now</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <button class="btn btn-outline-primary" title="Edit Details">Edit Details</button>
            </div>
            <div class="ul-wrap">
                <ul class="restro-info">
                    <li>Restaurant</li>
                    <li>Italian, Mediterranean</li>
                    <li>$34-$85</li>
                    <li>Top 20 places</li>
                </ul>
                <div class="btn-grps">
                    <a href="javascript: void(0);" title="Like">
                        <img src="./assets/images/ic-like.svg" alt="Icon">
                    </a>
                    <a href="javascript: void(0);" title="Share">
                        <img src="./assets/images/ic-share.svg" alt="Icon">
                    </a>
                </div>
            </div>
        </div>
        <div class="head-inner-right">
            <div class="ratings-wrap">
                <h5 class="rating-data">79 reviews</h5>
                <ngx-stars [readonly]="false" [size]="1" [color]="'#AE77A0'" [initialStars]="4.5"></ngx-stars>
            </div>
        </div>
    </div>


    <div class="nac-cta-outer">
        <div class="nav-cta-wrap">
            <div class="datepicker-grp">
                <input class="form-control datepicker-input" name="dp" [(ngModel)]="model" ngbDatepicker
                    placeholder="Enter Date" #d="ngbDatepicker" (click)="d.toggle()" [value]="getFormattedDate(model)"
                    autocomplete="off" />
                <img src="./assets/images/ic-arrow-down-dark.svg" alt="Icon" class="arrow">
            </div>
            <ng-select [(ngModel)]="timeSelect" class="ng-form-select custom time-select" placeholder="Enter Time">
                <ng-option *ngFor="let time of times" [value]="time.id">{{time.name}}</ng-option>
            </ng-select>
            <ng-select [(ngModel)]="peopleSelect" class="ng-form-select custom people-select" placeholder="People">
                <ng-option *ngFor="let people of peoples" [value]="people.id">{{people.name}}</ng-option>
            </ng-select>
            <button class="btn btn-primary" title="Find Table">Find Table</button>
        </div>

        <div class="user-cmt d-none d-lg-flex">
            <h5 class="cmt"><span>Marecenas yr vitore</span></h5>
            <span class="img-block">
                <img src="./assets/images/user-profile.png" alt="Profile">
            </span>
        </div>
    </div>
    <div class="slider-with-thumb-wrap">
        <div class="navigation-wrap">
            <div class="keen-slider view-slide top-slider" #sliderRef>
                <div class="keen-slider__slide number-slide1">
                    <!-- <div class="bg-img">
                        <img src="./assets/images/landing-hero-bg.webp" alt="Image" />
                    </div> -->
                    <div class="keen-slider inner-slider" #sliderRefInner style="min-width: 100%; max-width: 100%">
                        <div class="keen-slider__slide number-slide1">
                            <div class="bg-img">
                                <img src="./assets/images/landing-hero-bg.webp" alt="Image" />
                            </div>
                        </div>
                        <div class="keen-slider__slide number-slide2">
                            <div class="bg-img">
                                <img src="./assets/images/demo.jpg" alt="Image" />
                            </div>
                        </div>
                        <div class="keen-slider__slide number-slide3">
                            <div class="bg-img">
                                <img src="./assets/images/landing-hero-bg.webp" alt="Image" />
                            </div>
                        </div>
                        <div class="keen-slider__slide number-slide4">
                            <div class="bg-img">
                                <img src="./assets/images/demo.jpg" alt="Image" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="keen-slider__slide number-slide2">
                    <div class="bg-img">
                        <img src="./assets/images/landing-hero-bg-2.webp" alt="Image" />
                    </div>
                </div>
                <div class="keen-slider__slide number-slide3">
                    <div class="bg-img">
                        <img src="./assets/images/landing-hero-bg.webp" alt="Image" />
                    </div>
                </div>
                <div class="keen-slider__slide number-slide4">
                    <div class="bg-img">
                        <img src="./assets/images/landing-hero-bg-2.webp" alt="Image" />
                    </div>
                </div>
                <div class="keen-slider__slide number-slide5">
                    <div class="bg-img">
                        <img src="./assets/images/landing-hero-bg.webp" alt="Image" />
                    </div>
                </div>
                <div class="keen-slider__slide number-slide6">
                    <div class="bg-img">
                        <img src="./assets/images/landing-hero-bg-2.webp" alt="Image" />
                    </div>
                </div>
            </div>
            <button class="d-sm-none" [ngClass]="
                  'btn arrow arrow-prev ' + (currentSlide === 0 ? 'arrow--disabled' : '')
                " (click)="slider.prev()">
                <img src="./assets/images/ic-slider-prev.svg" alt="Previous Icon">
            </button>
            <button class="d-sm-none" *ngIf="slider" [ngClass]="
                  'btn arrow arrow-next ' +
                  (slider.track.details.slides.length - 1 === currentSlide
                    ? 'arrow--disabled'
                    : '')
                " (click)="slider.next()">
                <img src="./assets/images/ic-slider-next.svg" alt="Previous Icon">
            </button>
        </div>
        <div class="thumb-wrap">
            <div class="keen-slider thumbnail" #thumbnailRef>
                <div class="keen-slider__slide number-slide1">
                    <div class="thumb-bg-img">
                        <img src="./assets/images/slider-thumb-3.png" alt="Image" />
                        <span class="text">Interior</span>
                    </div>
                </div>
                <div class="keen-slider__slide number-slide2">
                    <div class="thumb-bg-img">
                        <img src="./assets/images/slider-thumb-2.png" alt="Image" />
                        <span class="text">Food</span>
                    </div>
                </div>
                <div class="keen-slider__slide number-slide3">
                    <div class="thumb-bg-img">
                        <img src="./assets/images/slider-thumb-1.png" alt="Image" />
                        <span class="text">Interior</span>
                    </div>
                </div>
                <div class="keen-slider__slide number-slide4">
                    <div class="thumb-bg-img">
                        <img src="./assets/images/slider-thumb-4.png" alt="Image" />
                        <span class="text">Food</span>
                    </div>
                </div>
                <div class="keen-slider__slide number-slide5">
                    <div class="thumb-bg-img">
                        <img src="./assets/images/slider-thumb-2.png" alt="Image" />
                        <span class="text">Cafe</span>
                    </div>
                </div>
                <div class="keen-slider__slide number-slide6">
                    <div class="thumb-bg-img">
                        <img src="./assets/images/slider-thumb-1.png" alt="Image" />
                        <span class="text">Interior</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="location-map-frame">
        <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.7030329876966!2d72.49795187594992!3d23.03467351587532!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8352e403437b%3A0xdc9d4dae36889fb9!2sTatvaSoft!5e0!3m2!1sen!2sin!4v1706782801389!5m2!1sen!2sin"
            style="border:0;" allowfullscreen="" loading="lazy" frameBorder="0"
            referrerpolicy="no-referrer-when-downgrade">
        </iframe>
        <div class="link-wrap-outer">
            <div class="links-wrap">
                <div class="row">
                    <div class="col-12">
                        <p ngbTooltip="Sun-Sat 12:00 AM - 5:30 PM" tooltipClass="theme-tooltip">
                            <span class="icon-wrap">
                                <img src="./assets/images/ic-clock-primary-light.svg" alt="Icon">
                            </span>
                            Sun-Sat 12:00 AM - 5:30 PM
                        </p>
                    </div>
                    <div class="col-12">
                        <p>
                            <span class="icon-wrap">
                                <img src="./assets/images/ic-location.svg" alt="Icon">
                            </span>
                            490 Pacific Ave
                            , San Francisco, CA 94133
                        </p>
                    </div>
                    <div class="col-6 col-md-4">
                        <a href="tel:+14157758508">
                            <span class="icon-wrap">
                                <img src="./assets/images/ic-phone.svg" alt="Icon">
                            </span>
                            +1 415-775-8508
                        </a>
                    </div>
                    <div class="col-6 col-md-3">
                        <a href="http://website">
                            <span class="icon-wrap">
                                <img src="./assets/images/ic-web.svg" alt="Icon">
                            </span>
                            <span class="text">website</span>
                            <img src="./assets/images/ic-arrow-tr.svg" alt="Icon" class="arrow">
                        </a>
                    </div>
                    <div class="col-12">
                        <a href="https://twitter.com/?lang=en">
                            <span class="icon-wrap">
                                <img src="./assets/images/ic-twitter.svg" alt="Icon">
                            </span>
                            <span class="text">twitter</span>
                            <img src="./assets/images/ic-arrow-tr.svg" alt="Icon" class="arrow">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-8 order-1 order-lg-0">
            <div class="food-menu-top-nav">
                <div class="food-menu-top-inner">
                    <div ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills">
                        <ng-container ngbNavItem="top">
                            <button ngbNavLink>
                                <svg width="12" height="11" viewBox="0 0 12 11" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M3.36378 6.18358L5.13986 4.46906L0.734179 0.222135C0.264019 0.677308 0 1.29387 0 1.93666C0 2.57944 0.264019 3.19601 0.734179 3.65118L3.36378 6.18358ZM7.61884 5.08702C8.57906 5.51716 9.92837 5.21424 10.9262 4.25096C12.1249 3.09381 12.3571 1.43381 11.4346 0.543229C10.5183 -0.341295 8.79871 -0.123193 7.59374 1.03396C6.59587 1.99724 6.28208 3.29979 6.72766 4.22673L0.602385 10.1397L1.48729 10.9939L5.81138 6.83183L10.1292 11L11.0141 10.1458L6.69628 5.9776L7.61884 5.08702Z"
                                        fill="currentcolor" />
                                </svg>
                                Menu
                            </button>
                            <ng-template ngbNavContent>
                                <div class="data-showcase-grid food-dish-grid">
                                    <div class="food-tab-outer">
                                        <ul ngbNav #dishNav="ngbNav" [(activeId)]="activeDishPanel" class="nav-tabs">
                                            <li [ngbNavItem]="1">
                                                <button ngbNavLink>Entree</button>
                                                <ng-template ngbNavContent>
                                                    <div class="food-dish-wrap">
                                                        <p>
                                                            Data 1
                                                        </p>
                                                    </div>
                                                </ng-template>
                                            </li>
                                            <li [ngbNavItem]="2">
                                                <button ngbNavLink>Main</button>
                                                <ng-template ngbNavContent>
                                                    <div class="food-dish-wrap">
                                                        <ul class="dish-ul">
                                                            <li>
                                                                <img src="./assets/images/dish-1.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-8.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-2.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-3.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-4.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-5.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-6.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>

                                                            <li>
                                                                <img src="./assets/images/dish-7.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-8.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-2.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-3.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-4.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-5.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-6.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </ng-template>
                                            </li>
                                            <li [ngbNavItem]="3">
                                                <button ngbNavLink>Sides</button>
                                                <ng-template ngbNavContent>
                                                    <div class="food-dish-wrap">
                                                        <ul class="dish-ul">
                                                            <li>
                                                                <img src="./assets/images/dish-1.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-8.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-2.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-1.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-8.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-1.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </ng-template>
                                            </li>
                                            <li [ngbNavItem]="4">
                                                <button ngbNavLink>Dessert</button>
                                                <ng-template ngbNavContent>
                                                    <div class="food-dish-wrap">
                                                        <ul class="dish-ul">
                                                            <li>
                                                                <img src="./assets/images/dish-1.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-8.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <img src="./assets/images/dish-2.jpg" alt="Food"
                                                                    class="food-preview">
                                                                <div class="dish-inner">
                                                                    <div class="dish-info-wrap">
                                                                        <h4 class="dish-name">Pizza Margherita</h4>
                                                                        <span class="lines"></span>
                                                                        <h4 class="dish-price">$10</h4>
                                                                    </div>
                                                                    <p class="dish-info">Buffala Mozzarella, Fresh
                                                                        Basil, Parmigiano</p>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </ng-template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div [ngbNavOutlet]="dishNav" class="mt-2"></div>
                                </div>
                            </ng-template>
                        </ng-container>
                        <ng-container ngbNavItem="bottom">
                            <button ngbNavLink>
                                <svg width="12" height="11" viewBox="0 0 12 11" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M0.741789 10.2558L0.379189 10.5948L0.741789 10.2558C0.590387 10.0939 0.5 9.86749 0.5 9.625V8.70833C0.5 8.46584 0.590387 8.23947 0.741789 8.07756C0.892129 7.91678 1.08858 7.83333 1.28571 7.83333H3.85714C4.05428 7.83333 4.25073 7.91678 4.40107 8.07756C4.55247 8.23947 4.64286 8.46584 4.64286 8.70833V9.625C4.64286 9.86749 4.55247 10.0939 4.40107 10.2558C4.25073 10.4166 4.05428 10.5 3.85714 10.5H1.28571C1.08857 10.5 0.892129 10.4166 0.741789 10.2558ZM0.741789 0.744225C0.89213 0.583444 1.08858 0.5 1.28571 0.5H10.7143C10.9114 0.5 11.1079 0.583444 11.2582 0.744225C11.4096 0.906141 11.5 1.13251 11.5 1.375V4.125C11.5 4.36749 11.4096 4.59386 11.2582 4.75577C11.1079 4.91656 10.9114 5 10.7143 5H1.28571C1.08858 5 0.892129 4.91656 0.741789 4.75577C0.590387 4.59386 0.5 4.36749 0.5 4.125V1.375C0.5 1.13251 0.590387 0.906141 0.741789 0.744225ZM7.59893 8.07756C7.74927 7.91678 7.94572 7.83333 8.14286 7.83333H10.7143C10.9114 7.83333 11.1079 7.91678 11.2582 8.07756C11.4096 8.23947 11.5 8.46584 11.5 8.70833V9.625C11.5 9.86749 11.4096 10.0939 11.2582 10.2558C11.1079 10.4166 10.9114 10.5 10.7143 10.5H8.14286C7.94572 10.5 7.74927 10.4166 7.59893 10.2558C7.44753 10.0939 7.35714 9.86749 7.35714 9.625V8.70833C7.35714 8.46584 7.44753 8.23947 7.59893 8.07756Z"
                                        stroke="currentcolor" />
                                </svg>
                                Feed
                            </button>
                            <ng-template ngbNavContent>
                                <div class="data-showcase-grid">
                                    <div class="public-review-wrap">
                                        <div class="review-wrap-body">
                                            <div class="review-card">
                                                <div class="review-card-head">
                                                    <img src="./assets/images/review-avatar-2.png" alt="Image"
                                                        class="review-profile">
                                                    <div class="review-info-block">
                                                        <h4 class="food-name">Stepher Harper</h4>
                                                        <h6 class="place-type">5 Jun 2023</h6>
                                                    </div>
                                                    <div class="rating-block">
                                                        <div class="ratig-inner">
                                                            <h5 class="ratings">4.3</h5>
                                                            <span class="rating-icon">
                                                                <img src="./assets/images/ic-primary-rating.svg"
                                                                    alt="Rating">
                                                            </span>
                                                        </div>
                                                        <p class="rated-time">2 days ago</p>
                                                    </div>
                                                </div>
                                                <div class="review-card-body">
                                                    <h4 class="review-text-data">
                                                        Love this place! Fresh and delicious food and they even make
                                                        their own bread. My go to spot for breakfast and lately a
                                                        quick stop for happy hour.
                                                    </h4>
                                                    <ul class="info-showcase">
                                                        <li>
                                                            <img src="./assets/images/ic-photo.svg" alt="Star">
                                                            3 photos
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="reply-block">
                                                    <div class="review-card-head">
                                                        <img src="./assets/images/review-avatar-1.png" alt="Image"
                                                            class="review-profile">
                                                        <div class="review-info-block">
                                                            <h4 class="food-name">Cotogna</h4>
                                                            <h6 class="place-type">Restaurant</h6>
                                                        </div>
                                                    </div>
                                                    <div class="review-card-body">
                                                        <h4 class="review-text-data">
                                                            Thank you so much
                                                        </h4>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="review-card">
                                                <div class="review-card-head">
                                                    <img src="./assets/images/review-avatar-2.png" alt="Image"
                                                        class="review-profile">
                                                    <div class="review-info-block">
                                                        <h4 class="food-name">Homeroom</h4>
                                                        <h6 class="place-type">5 Jun 2023</h6>
                                                    </div>
                                                    <div class="rating-block">
                                                        <div class="ratig-inner">
                                                            <h5 class="ratings">4.3</h5>
                                                            <span class="rating-icon">
                                                                <img src="./assets/images/ic-primary-rating.svg"
                                                                    alt="Rating">
                                                            </span>
                                                        </div>
                                                        <p class="rated-time">2 days ago</p>
                                                    </div>
                                                </div>
                                                <div class="review-card-body">
                                                    <h4 class="review-text-data">
                                                        Super! We booked the sunset ride with cowboy bbq. What a blast!
                                                        Beautiful scenery, well kept horses and yummy bbq.
                                                        Perfect! I can't wait to try the winery tour next time!
                                                    </h4>
                                                    <ul class="info-showcase">
                                                        <li>
                                                            <img src="./assets/images/ic-photo.svg" alt="Star">
                                                            5 photos
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                        <ng-container ngbNavItem="middle">
                            <button ngbNavLink>
                                <svg width="13" height="11" viewBox="0 0 13 11" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M3.38975 1.36086L3.05663 2.35714H2.03125C1.49253 2.35714 0.975873 2.56409 0.594939 2.93247C0.214006 3.30084 0 3.80047 0 4.32143V9.03571C0 9.55667 0.214006 10.0563 0.594939 10.4247C0.975873 10.793 1.49253 11 2.03125 11H10.9688C11.5075 11 12.0241 10.793 12.4051 10.4247C12.786 10.0563 13 9.55667 13 9.03571V4.32143C13 3.80047 12.786 3.30084 12.4051 2.93247C12.0241 2.56409 11.5075 2.35714 10.9688 2.35714H9.94256L9.61025 1.36086C9.47823 0.965376 9.21991 0.620574 8.87244 0.376043C8.52496 0.131512 8.10624 -0.000147407 7.6765 1.23852e-07H5.3235C4.89376 -0.000147407 4.47504 0.131512 4.12756 0.376043C3.78009 0.620574 3.52177 0.965376 3.38975 1.36086ZM2.03125 3.14286H3.64812L4.16244 1.60286C4.24154 1.36545 4.39648 1.15843 4.60497 1.01159C4.81347 0.864756 5.06476 0.785669 5.32269 0.785714H7.67731C7.9351 0.785835 8.18621 0.864999 8.39454 1.01183C8.60287 1.15865 8.7577 1.36558 8.83675 1.60286L9.35106 3.14286H10.9688C11.292 3.14286 11.602 3.26703 11.8305 3.48805C12.0591 3.70908 12.1875 4.00885 12.1875 4.32143V9.03571C12.1875 9.34829 12.0591 9.64806 11.8305 9.86909C11.602 10.0901 11.292 10.2143 10.9688 10.2143H2.03125C1.70802 10.2143 1.39802 10.0901 1.16946 9.86909C0.940904 9.64806 0.8125 9.34829 0.8125 9.03571V4.32143C0.8125 4.00885 0.940904 3.70908 1.16946 3.48805C1.39802 3.26703 1.70802 3.14286 2.03125 3.14286Z"
                                        fill="currentcolor" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M4.0625 6.28585C4.0625 6.91101 4.31931 7.51056 4.77643 7.95261C5.23355 8.39466 5.85353 8.643 6.5 8.643C7.14647 8.643 7.76645 8.39466 8.22357 7.95261C8.68069 7.51056 8.9375 6.91101 8.9375 6.28585C8.9375 5.6607 8.68069 5.06115 8.22357 4.6191C7.76645 4.17705 7.14647 3.92871 6.5 3.92871C5.85353 3.92871 5.23355 4.17705 4.77643 4.6191C4.31931 5.06115 4.0625 5.6607 4.0625 6.28585ZM8.125 6.28585C8.125 6.70262 7.95379 7.10232 7.64905 7.39702C7.3443 7.69172 6.93098 7.85728 6.5 7.85728C6.06902 7.85728 5.6557 7.69172 5.35095 7.39702C5.04621 7.10232 4.875 6.70262 4.875 6.28585C4.875 5.86909 5.04621 5.46939 5.35095 5.17469C5.6557 4.87999 6.06902 4.71443 6.5 4.71443C6.93098 4.71443 7.3443 4.87999 7.64905 5.17469C7.95379 5.46939 8.125 5.86909 8.125 6.28585Z"
                                        fill="currentcolor" />
                                </svg>
                                Photos</button>
                            <ng-template ngbNavContent>
                                <div class="data-showcase-grid gallery-grid">
                                    <div class="photo-tab-wrap">
                                        <div class="row">
                                            <div class="col-sm-6 col-md-4">
                                                <div class="gallery-preview">
                                                    <div class="img-block">
                                                        <img src="./assets/images/demo-2.jpg" alt="Image">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <div class="gallery-preview">
                                                    <div class="img-block">
                                                        <img src="./assets/images/demo-1.jpg" alt="Image">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <div class="gallery-preview">
                                                    <div class="img-block">
                                                        <img src="./assets/images/demo-3.jpg" alt="Image">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <div class="gallery-preview">
                                                    <div class="img-block">
                                                        <img src="./assets/images/demo-4.jpg" alt="Image">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <div class="gallery-preview">
                                                    <div class="img-block">
                                                        <img src="./assets/images/demo-2.jpg" alt="Image">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-md-4">
                                                <div class="gallery-preview">
                                                    <div class="img-block">
                                                        <img src="./assets/images/demo-1.jpg" alt="Image">
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                        <a class="btn btn-demo" routerLink="/ui-gallery">
                            <svg width="13" height="11" viewBox="0 0 13 11" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M3.38975 1.36086L3.05663 2.35714H2.03125C1.49253 2.35714 0.975873 2.56409 0.594939 2.93247C0.214006 3.30084 0 3.80047 0 4.32143V9.03571C0 9.55667 0.214006 10.0563 0.594939 10.4247C0.975873 10.793 1.49253 11 2.03125 11H10.9688C11.5075 11 12.0241 10.793 12.4051 10.4247C12.786 10.0563 13 9.55667 13 9.03571V4.32143C13 3.80047 12.786 3.30084 12.4051 2.93247C12.0241 2.56409 11.5075 2.35714 10.9688 2.35714H9.94256L9.61025 1.36086C9.47823 0.965376 9.21991 0.620574 8.87244 0.376043C8.52496 0.131512 8.10624 -0.000147407 7.6765 1.23852e-07H5.3235C4.89376 -0.000147407 4.47504 0.131512 4.12756 0.376043C3.78009 0.620574 3.52177 0.965376 3.38975 1.36086ZM2.03125 3.14286H3.64812L4.16244 1.60286C4.24154 1.36545 4.39648 1.15843 4.60497 1.01159C4.81347 0.864756 5.06476 0.785669 5.32269 0.785714H7.67731C7.9351 0.785835 8.18621 0.864999 8.39454 1.01183C8.60287 1.15865 8.7577 1.36558 8.83675 1.60286L9.35106 3.14286H10.9688C11.292 3.14286 11.602 3.26703 11.8305 3.48805C12.0591 3.70908 12.1875 4.00885 12.1875 4.32143V9.03571C12.1875 9.34829 12.0591 9.64806 11.8305 9.86909C11.602 10.0901 11.292 10.2143 10.9688 10.2143H2.03125C1.70802 10.2143 1.39802 10.0901 1.16946 9.86909C0.940904 9.64806 0.8125 9.34829 0.8125 9.03571V4.32143C0.8125 4.00885 0.940904 3.70908 1.16946 3.48805C1.39802 3.26703 1.70802 3.14286 2.03125 3.14286Z"
                                    fill="currentcolor" />
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M4.0625 6.28585C4.0625 6.91101 4.31931 7.51056 4.77643 7.95261C5.23355 8.39466 5.85353 8.643 6.5 8.643C7.14647 8.643 7.76645 8.39466 8.22357 7.95261C8.68069 7.51056 8.9375 6.91101 8.9375 6.28585C8.9375 5.6607 8.68069 5.06115 8.22357 4.6191C7.76645 4.17705 7.14647 3.92871 6.5 3.92871C5.85353 3.92871 5.23355 4.17705 4.77643 4.6191C4.31931 5.06115 4.0625 5.6607 4.0625 6.28585ZM8.125 6.28585C8.125 6.70262 7.95379 7.10232 7.64905 7.39702C7.3443 7.69172 6.93098 7.85728 6.5 7.85728C6.06902 7.85728 5.6557 7.69172 5.35095 7.39702C5.04621 7.10232 4.875 6.70262 4.875 6.28585C4.875 5.86909 5.04621 5.46939 5.35095 5.17469C5.6557 4.87999 6.06902 4.71443 6.5 4.71443C6.93098 4.71443 7.3443 4.87999 7.64905 5.17469C7.95379 5.46939 8.125 5.86909 8.125 6.28585Z"
                                    fill="currentcolor" />
                            </svg>
                            Gallery
                        </a>
                    </div>
                    <div class="btn-grps-outer d-none d-md-flex">

                        <button _ngcontent-ng-c2684904867="" class="btn btn-blue">
                            <img src="./assets/images/ic-points.svg" alt="Icon">
                            55 points
                        </button>
                        <button class="btn btn-danger btn-order" title="Order Here!">Order Here!</button>
                    </div>
                </div>

                <div [ngbNavOutlet]="nav" class=""></div>
            </div>

        </div>
        <div class="col-lg-4 order-0 order-lg-1">
            <div class="advertisement-wrapper">
                <div class="row">
                    <div class="col-sm-6 col-lg-12">
                        <div class="advertisement-inner">
                            <img src="./assets/images/advertisement-1.png" alt="Advertisement">
                        </div>
                    </div>
                    <div class="col-sm-6 col-lg-12 d-none d-sm-block">
                        <div class="advertisement-inner">
                            <img src="./assets/images/advertisement-2.png" alt="Advertisement">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>